import { getCanvas } from "./CanvasManager";
import { sceneHistory } from "./SceneHistory";

class HistoryService {

  save() {
    const canvas = getCanvas();

    if (!canvas) return;

    sceneHistory.save(canvas);
  }

  undo() {
    const canvas = getCanvas();

    if (!canvas) return;

    sceneHistory.undo(canvas);
  }

  redo() {
    const canvas = getCanvas();

    if (!canvas) return;

    sceneHistory.redo(canvas);
  }

}

export const historyService = new HistoryService();